import { PAYMENT_METHOD_TYPES } from '../../../util/enum/api/paymentTypes';

export const findDefaultPaymentMethod = (paymentMethods) => {
  if (!Array.isArray(paymentMethods) || paymentMethods.length === 0)
    return null;
  return (
    paymentMethods.find((m) => m?.IsDefault) ||
    paymentMethods.find((m) => m?.CreditCardType) ||
    paymentMethods[0]
  );
};

export const formatPaymentMethodLabel = (paymentMethod, t) => {
  if (!paymentMethod) return '';
  if (
    paymentMethod.PaymentMethodType === PAYMENT_METHOD_TYPES.ACCOUNT_BALANCE
  ) {
    return t('buyWizard.payment.paymentMethods.AccountBalance');
  }
  if (paymentMethod.PaymentMethodType === PAYMENT_METHOD_TYPES.ACH) {
    return `${paymentMethod.BankName}, ***${paymentMethod.BankAccountMask}`;
  }
  if (paymentMethod.PaymentMethodType === PAYMENT_METHOD_TYPES.CREDIT_CARD) {
    return `${t('buyWizard.payment.paymentMethods.CreditCard')} ***${
      paymentMethod.Last4Digits
    }`;
  }
  return '';
};
